import {Component, Input} from '@angular/core';
import {
    faAddressBook,
    faAddressCard, faArrowCircleLeft,
    faArrowCircleRight,
    faArrowDownToSquare, faArrowProgress,
    faArrowUpFromSquare,
    faBarcodeScan,
    faBars,
    faBoxOpen,
    faBuilding, faBuildingLock, faCalendar,
    faCalendarLinesPen,
    faCaretDown,
    faCaretLeft,
    faCaretUp, faCartPlus, faChartMixed,
    faCheckCircle,
    faCircleExclamation,
    faClipboardList, faClock, faClone, faCloudArrowDown, faContainerStorage,
    faConveyorBeltArm,
    faConveyorBeltBoxes,
    faDashboard,
    faDisplayChartUp, faDisplayCode,
    faEye,
    faFile, faFileArrowDown, faFileCheck, faFileSpreadsheet, faFileXmark,
    faForklift,
    faGamepad,
    faGearCode, faGears,
    faHashtag,
    faHouse,
    faLockKeyhole,
    faLockKeyholeOpen,
    faMagnifyingGlass,
    faMinusCircle,
    faMoon,
    faMp3Player,
    faPenCircle,
    faPeopleCarryBox,
    faPlusCircle,
    faPrint,
    faQrcode,
    faRefresh,
    faSave, faSliders,
    faSort, faSparkle,
    faSun, faTrashCan,
    faTruckFast,
    faTruckRampBox,
    faUser, faUserClock,
    faWarehouse,
    faXmarkCircle
} from "@awesome.me/kit-86315a9e4d/icons/duotone/solid";
import {FaIconComponent, IconDefinition} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'icon',
    standalone: true,
    imports: [
        FaIconComponent
    ],
    templateUrl: './icon.component.html',
    styleUrl: './icon.component.scss'
})

export class IconComponent {
    @Input() icon: string | undefined;
    @Input() label: string | undefined;

    protected map: {[key: string]: IconDefinition[]} = {
        add: [faPlusCircle],
        address: [faAddressCard],
        admin: [faGearCode],
        back: [faCaretLeft],
        cancel: [faXmarkCircle],
        caretDown: [faCaretDown],
        caretUp: [faCaretUp],
        cartPlus: [faCartPlus],
        category: [faConveyorBeltBoxes],
        check: [faCheckCircle],
        contact: [faAddressBook],
        container: [faContainerStorage],
        copy: [faClone],
        customer: [faUser],
        dashboard: [faDashboard],
        date: [faCalendar],
        delete: [faMinusCircle],
        detail: [faEye],
        download: [faFileArrowDown],
        edit: [faPenCircle],
        erp: [faDisplayChartUp],
        erpdata: [faDisplayCode],
        forecast: [faChartMixed],
        home: [faHouse],
        inbound: [faArrowDownToSquare],
        import: [faCloudArrowDown],
        item: [faMp3Player],
        login: [faLockKeyhole],
        logout: [faLockKeyholeOpen],
        mandatory: [faCircleExclamation],
        manufacturer: [faConveyorBeltArm],
        menu: [faBars],
        moon: [faMoon],
        next: [faArrowCircleRight],
        outbound: [faArrowUpFromSquare],
        pick: [faBoxOpen],
        plan: [faCalendarLinesPen],
        previous: [faArrowCircleLeft],
        print: [faPrint],
        qrcode: [faQrcode],
        receive: [faTruckRampBox],
        refresh: [faRefresh],
        reporting: [faFileSpreadsheet],
        requirement: [faClipboardList],
        save: [faSave],
        scan: [faBarcodeScan],
        search: [faMagnifyingGlass],
        serial: [faHashtag],
        settings: [faGears],
        ship: [faTruckFast],
        sort: [faSort],
        store: [faForklift],
        subsidiary: [faBuilding],
        subsidiaryaccess: [faBuildingLock],
        sun: [faSun],
        ticket: [faFile],
        ticketCreated: [faSparkle],
        ticketStarted: [faArrowProgress],
        ticketWaiting: [faUserClock],
        ticketManufacturer: [faConveyorBeltArm, faClock],
        ticketCompleted: [faFileCheck],
        ticketClosed: [faFileXmark],
        transaction: [faPeopleCarryBox],
        trash: [faTrashCan],
        user: [faUser],
        warehouse: [faWarehouse],
        sliders: [faSliders],

        test: [faGamepad]
    }
}
